import React, { useEffect, useState } from 'react'
import Header from '../../components/Header'
import { authAxios } from '../../helpers/axios'
import { useParams } from 'react-router-dom'
import { ErrorToast, InfoToast } from '../../helpers/toasters'
import 'react-toastify/dist/ReactToastify.css';
import { getDateFormat } from '../../helpers/utils'
import Progress from '../../components/Progress'
import UpdateProductionReceiving from './components/UpdateProductionReceivings'
import ShipPopup from './components/ShipPopup'
import ModalImage from 'react-modal-image'
import InitiateManufacturing from './components/InitiateManufacturing'
import InitiateProduct from './components/InitiateProduct'
import AddBlend from './components/AddBlend'
import CombineBlends from './components/CombineBlends'
import RevertBlendPopup from './components/RevertBlend'

export default function ManufacturingOrderInfo() {

    const {id} = useParams();
    const [orders,setOrders] = useState({productionProducts:[]})
    const [orderInfo,setOrderInfo] = useState({productionProducts:[]})
    const [showShip,setShowShip] = useState(false)
    const [showUpdate,setShowUpdate] = useState({status:false,item:null})
    const [activeTab,setActiveTab] = useState('orders')
    const [manufacturing,setManufacturing] = useState(false)
    const [showProductInitiate,setShowProductInitiate] = useState(false)
    const [showAddBlend,setShowAddBlend] = useState(false)
    const [submitting,setSubmitting] = useState(false)
    const [showCombineBlends,setShowCombineBlends] = useState(false)
    const [showRevertBlend,setShowRevertBlend] = useState(false)

    const RightContent = ()=>
    {
        return <div>
          {orderInfo.status === 'pending' ? <button type='button' className='btn-md mr-2' onClick={()=>setManufacturing(true)}>Intiate Manufacturing</button> : null}
          {!orderInfo.salesOrder?.shippingOrder && orderInfo.progressPercentage >= 10 ? <button type='button' className='btn-md' onClick={()=>setShowShip(id)}>Ready to Ship</button> : null}
        </div>
    }

    async function getOrderInfo(){

        try 
        {
            let ordersRes = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/production/${id}`)
            if(ordersRes.data) setOrderInfo(ordersRes.data)
        } catch (error) {
            ErrorToast('Error getting Orders')
        }
    }
    useEffect(()=>
    {
        getOrderInfo();
    },[])

    const onShip = async(e,id)=>
        {
            try 
            {
                e.preventDefault()
                setSubmitting(true)
                let res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/shipping/${id}`); 
                await getOrderInfo()
                setShowShip(false)
                setSubmitting(false)
                InfoToast('Shipping Order Created')
            } catch (error) {
                setSubmitting(false)
                ErrorToast(error.response.data.error ? error.response.data.error : 'Error creating shipping order')
            }
        }

    const onReceiving = async(e,data)=>
        {
            try 
            {
                e.preventDefault()
                setSubmitting(true)
                let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/production/receiving/${id}`,data); 
                await getOrderInfo()
                setShowUpdate({status:null,item:null})
                setSubmitting(false)
                InfoToast('Receiving Updated')
            } catch (error) {
                setSubmitting(false)
                ErrorToast(error.response.data.error ? error.response.data.error : 'Error Adding Blend')
            }
        }


    const onInitiateManufacturing = async(e,data)=>
    {
        try 
        {
            e.preventDefault()
            setSubmitting(true) 
            let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/production/initiate/${id}`,data); 
            await getOrderInfo()
            setSubmitting(false)
            InfoToast('Manufacturing Initiated')
            setManufacturing(false)
        } catch (error) {
            setManufacturing(false)
            InfoToast(error.response.data.error ? error.response.data.error : 'Error initiating manufacturing')
        }
    }

    const onRevertBlend = async(e,data)=>
    {
        try 
        {
            e.preventDefault()
            setSubmitting(true) 
            let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/production/revert-blend`,{productionBlendId:data.productionBlendId,productionId:id}); 
            await getOrderInfo()
            setSubmitting(false)
            InfoToast('Blend Reverted')
            setShowRevertBlend(false)
        } catch (error) {
            setSubmitting(false)
            ErrorToast(error.response.data.error ? error.response.data.error : 'Error Reverting Blend')
        }
    }

    const onAddBlend = async(e,data)=>
    {
        try 
        {
            e.preventDefault()
            setSubmitting(true)
            let res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/production/add-blends/${id}`,data)
            await getOrderInfo()
            setSubmitting(false)
            setShowAddBlend(false)
            InfoToast('Blend Added')
        } catch (error) {
            setSubmitting(false)
            ErrorToast(error.response.data.error ? error.response.data.error : 'Error Adding Blend')
        }
    }

    const onInitiateProduct = async(e,productionProductId,data)=>
    {
        try {
            e.preventDefault()
            setSubmitting(true)
            let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/production/initiate-product/${productionProductId}`,data); 
            await getOrderInfo()
            InfoToast('Product Manufacturing Initiated')
            setShowProductInitiate(false)
            setSubmitting(false)
        } catch (error) {
            setSubmitting(false)
            ErrorToast(error.response.data.error ? error.response.data.error : 'Error initiating product manufacturing')
        }
    }

    const onCombineBlends = async(e,data)=>
    {
        try {
            e.preventDefault()
            setSubmitting(true)
            let res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/production/combine-blends/${id}`,{selectedToBlendId:data.selectedToBlendId,selectedFromBlendId:data.selectedFromBlendId}); 
            await getOrderInfo()
            setSubmitting(false)
            InfoToast('Blends Combined')
            setShowCombineBlends(false)
        } catch (error) {
            setSubmitting(false)
            ErrorToast(error.response.data.error ? error.response.data.error : 'Error combining blends')
        }
    }
  return (
    <>
        <Header title={`#${orderInfo?.salesOrder?.orderId}`} parentLink='/manufacturing' parentTitle='Manufacturing Order Management' RightContent={RightContent}/>
        {/* <div className=' flex justify-between border-b border-[#e3e3e3] bg-white'>
        </div> */}
        <div className='block flex-1 overflow-scroll bg-white w-full py-10'>
        <div className='grid grid-cols-4 gap-6 w-full border-b border-[#e3e3e3] pb-6 px-4 mb-10'>
            <div>
                <label className='uppercase font-medium text-[#959595] tracking-normal'>Sales Order ID</label>
                <p className='text-sm text-black font-medium'>#{orderInfo?.salesOrder?.orderId}</p>
            </div>
            <div>
                <label className='uppercase font-medium text-[#959595] tracking-normal'>ordered Date</label>
                <p className='text-sm text-black font-medium'>{orderInfo?.createdAt ? getDateFormat(orderInfo?.createdAt) : 'Not Available'}</p>
            </div>
            <div>
                <label className='uppercase font-medium text-[#959595] tracking-normal'>Expected Delivery Date</label>
                <p className='text-sm text-black font-medium'>{orderInfo?.expectedDeliveryDate ? getDateFormat(orderInfo?.expectedDeliveryDate) : 'Not Available'}</p>
            </div>
            <div>
                <label className='uppercase font-medium text-[#959595] tracking-normal'>Buyer Name</label>
                <p className='text-sm text-black font-medium'>{orderInfo?.salesOrder?.buyer?.name}</p>
            </div>
            <div>
                <label className='uppercase font-medium text-[#959595] tracking-normal'>Contact Person</label>
                <p className='text-sm text-black font-medium'>{orderInfo.salesOrder?.buyer?.contactPerson ? orderInfo.salesOrder?.buyer.contactPerson : 'Not Available'}</p>
            </div>
            <div>
                <label className='uppercase font-medium text-[#959595] tracking-normal'>Contact Number</label>
                <p className='text-sm text-black font-medium'>{orderInfo?.salesOrder?.buyer?.contactNumber ? orderInfo?.salesOrder?.buyer?.contactNumber : 'Not Available'}</p>
            </div>
            <div>
                <label className='uppercase font-medium text-[#959595] tracking-normal'>Status</label>
                <p className='text-sm text-black font-medium capitalize'>{orderInfo?.status}</p>
            </div>

        </div>

        <div className='bg-white w-full flex-1 flex overflow-scroll mt-10'>
            <table className=' table-auto w-full flex-1 '>
                <thead className='bg-[#f9f9f9] w-full'>
                    <tr className='w-full'>
                    {/* <td><p className='cursor-pointer flex items-center hover:text-black'>SKU</p></td> */}
                
                    <td><p className='cursor-pointer flex items-center hover:text-black'>Name/SKU</p></td>

                    <td><p className='cursor-pointer flex items-center hover:text-black'>Total Weight / Blend Used</p></td>
                    <td><p className='cursor-pointer flex items-center hover:text-black'>Progress</p></td>

                    <td><p className='cursor-pointer flex items-center hover:text-black'>Manf./Total Cartons</p></td>
                    

                    <td><p className='cursor-pointer flex items-center hover:text-black'>Action</p></td>
                    </tr>
                </thead>
                <tbody>
                    {
                        orderInfo.productionProducts.map((item,index)=>
                        {
                            return <tr>
                                <td className='capitalize w-full'>
                                <div className="image-preview mr-2 ">
                                        <ModalImage small={`${process.env.REACT_APP_STATIC_URL}/${item.product.image}`} medium={`${process.env.REACT_APP_STATIC_URL}/${item.product.image}`} alt={item.product.name} className="rounded-full h-[32px] w-[32px] image-preview inline-block"/>
                                    </div>
                                    <div>
                                        <p className='text-sm font-medium my-0'>{item.product.name}</p>
                                        <p className='text-[12px] text-[#959595] font-regular my-0'>#{item.product.sku}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{(item.product.weight/1000) * item.quantity} Kg</p>
                                        <p className='text-[12px] text-[#959595] font-regular my-0'>{item.weightUsed}Kg</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div>
                                        <Progress percentage={item.progressPercentage}/>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                    <div>
                                    <p className='text-sm font-medium my-0'>{item.finishedCartons ? item.finishedCartons : 0} ({item.finishedQuantity ? item.finishedQuantity : 0})</p>
                                        <p className='text-[12px] text-[#959595] font-regular my-0'>{item.cartons} ({item.quantity})</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                    {/* {item.status === 'pending' ? <button className='btn-xs' onClick={()=>setShowProductInitiate(item.id)}>Initiate Product</button> : null} */}
                                    {orderInfo.status === 'pending' || orderInfo.status === 'initiated' ? <button className='btn-xs' onClick={()=>setShowUpdate({status:true,item:item})}>Update Quantity</button> : null}
                                    </div>
                                </td>
                            </tr>
                        })
                    }
                </tbody>
            </table>
        </div>

         <div className='mt-12'>
        <div className='px-6 mb-6 flex justify-between'>
        <p className='text-sm font-medium underline'>Blend Used For Production</p>
        <div className='flex gap-2'>
        { orderInfo.productionBlends?.length > 1 ? <button type='button' className='btn-md' onClick={()=>setShowCombineBlends(true)}>Combine Blends</button> : null}
        { orderInfo.status === 'initiated' ? <button type='button' className='btn-md' onClick={()=>setShowAddBlend(true)}>Add More Blends</button> : null}
        </div>
        </div>
        {orderInfo.productionBlends?.length > 0 ?<table>
            <thead>
                <tr>
                    <th>Batch Number #</th>
                    <th>Blend Name</th>
                    <th>Initiation Weight</th>
                    <th>Used Weight</th>
                    <th>Remaining Weight</th>
                    <th>Total Cost</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {orderInfo?.productionBlends?.map((blend,index)=>
                <tr key={index}>
                    <td className='text-sm font-medium'>{blend?.blendUsed?.batchNumber}</td>
                    <td className='text-sm font-medium'>{blend?.blendUsed?.blendName ? blend?.blendUsed?.blendName : 'N/A'}</td>
                    <td className='text-sm font-medium'>{blend?.weightUsed}</td>
                    <td className='text-sm font-medium'><div className='items-center'><p>{blend?.weightUsed - blend?.weightRemaining}</p>
                    {
                        blend?.revertedWeight > 0 ? <p className='underline text-xs'>Reverted:{blend?.revertedWeight} Kg</p> : null
                    }
                    </div>
                    </td>
                    <td className='text-sm font-medium'>{blend?.weightRemaining ? blend?.weightRemaining : 0}</td>
                    <td className='text-sm font-medium'>{blend?.blendCost ? `Rs.${(blend?.blendCost).toFixed(2)}` : 0}</td>
                    <td className='text-sm font-medium'>
                       {blend?.weightRemaining > 0 ? <button type='button' className='btn-xs' onClick={()=>setShowRevertBlend({status:true,blend:blend})}>Revert Blend</button> : null}
                    </td>
                </tr>)}
            </tbody>
        </table> : null}
    </div> 
            
        </div>
        { showUpdate.status ? <UpdateProductionReceiving submitting={submitting} data={orderInfo} onClose={setShowUpdate} onSubmit={onReceiving} edit={showUpdate.item}/> : null}
        { showShip ? <ShipPopup submitting={submitting} onClose={setShowShip} onSubmit={onShip} edit={showShip}/> : null}
        { showRevertBlend.status ? <RevertBlendPopup submitting={submitting} onClose={setShowRevertBlend} onSubmit={onRevertBlend} edit={showRevertBlend.blend}/> : null}
        { manufacturing ? <InitiateManufacturing submitting={submitting} onClose={setManufacturing} onSubmit={onInitiateManufacturing} salesOrderId={orderInfo?.salesOrder?.id}/> : null}
        { showProductInitiate ? <InitiateProduct id={showProductInitiate} submitting={submitting} onClose={setShowProductInitiate} data={orderInfo} onSubmit={onInitiateProduct}/> : null}
        { showAddBlend ? <AddBlend submitting={submitting} onClose={setShowAddBlend} onSubmit={onAddBlend} salesOrderId={orderInfo?.salesOrder?.id}/> : null}
        { showCombineBlends ? <CombineBlends submitting={submitting} data={orderInfo} onClose={setShowCombineBlends} onSubmit={onCombineBlends} /> : null}
    </>
  )
}
